export const docCopy = {
  doc_layout_title: "The starting point for learning TypeScript",
  doc_layout_description:
    "Find TypeScript starter projects: from Angular to React or Node.js and CLIs.",
  doc_bootstrap_title: "Bootstrapping tools for TypeScript projects",
  doc_bootstrap_description:
    "Toolchains for building CLIs, Web Apps, APIs, and Apps.",
  doc_headline: "Learning Resources",
  doc_headline_ts_for_js_title: "TS for JS",
  doc_headline_ts_for_js_blurb:
    "An overview of TypeScript for engineers with a JavaScript background",
  doc_headline_ts_first_title: "Start with TS",
  doc_headline_ts_first_blurb:
    "A beginners introduction to JavaScript and TypeScript",
  doc_headline_handbook_title: "Handbook",
  doc_headline_handbook_blurb: "The TypeScript language reference",
  doc_headline_examples_title: "Examples",
  doc_headline_examples_blurb: "Comprehensive hands-on playground tutorials",
  doc_start_a_project: "Start a New Project",
  doc_start_a_project_desc:
    "Because TypeScript is a super-set of JavaScript, it doesn't have a default template - there would be too many. Instead, other projects have their own TypeScript bootstrap templates with their own context. These projects provide templates which include TypeScript support.",
  doc_node_npm: "Node with npm",
  doc_node_npm_tsdx_blurb: "Zero config tool for building TypeScript libraries",
  doc_node_npm_oclif_blurb: "Create command line tools your users love",
  doc_node_npm_gluegun_blurb:
    "A delightful toolkit for building TypeScript-powered command-line apps",
  doc_frameworks: "Web Frameworks",
  doc_frameworks_angular_blurb:
    "Makes writing beautiful apps be joyful and fun",
  doc_frameworks_ember_blurb: "A framework for ambitious web developers",
  doc_frameworks_react_blurb:
    "A JavaScript library for building user interfaces",
  doc_frameworks_vue_blurb: "The Progressive JavaScript Framework",
  doc_frameworks_ror_blurb: "Convention over configuration web framework",
  doc_frameworks_asp_blurb:
    "Framework for building modern, cloud-based, Internet-connected applications",
  doc_apis: "Node APIs",
  doc_apis_azure_blurb: "Build and deploy from VS Code in minutes",
  doc_apis_feather_blurb:
    "A framework for real-time applications and REST APIs",
  doc_apis_graphql_blurb: "Bootstrap your GraphQL server within seconds",
  doc_apis_nest_blurb:
    "A progressive Node.js framework for building efficient and scalable server-side applications",
  doc_apis_node_blurb: "A documented starter template from the TS team",
  doc_apis_wechat_blurb: "Use the WeChat JSSDK with TypeScript",
  doc_apis_loopback_blurb:
    "A highly extensible Node.js and TypeScript framework for building APIs and microservices",
  doc_apis_fastify_blurb: "A fast and low overhead web framework for Node.js",
  doc_react: "React Projects",
  doc_react_create_blurb: "Set up a modern web app by running one command",
  doc_react_gatsby_blurb:
    "Helps developers build blazing fast websites and apps",
  doc_react_next_blurb: "The React Framework",
  doc_react_razzle_blurb:
    "Server-rendered universal JavaScript applications with no configuration",
  doc_react_toolchains_title: "Recommended Toolchains",
  doc_react_toolchains_blurb: "Recommendations from the React Team",
  doc_apps: "Building Apps",
  doc_apps_electron_blurb: "Set up a modern web app by running one command",
  doc_apps_expo_blurb: "The fastest way to build an app",
  doc_apps_react_native_blurb: "Learn once, write anywhere",
  doc_apps_native_script_blurb:
    "Open source framework for building truly native mobile apps",
  doc_apps_make_code_blurb:
    "Brings computer science to life for all students with fun projects",
  doc_tooling: "Tooling",
  doc_tooling_babel_blurb: "Use next generation JavaScript, today",
  doc_tooling_parcel_blurb:
    "Blazing fast, zero configuration web application bundler",
  doc_tooling_webpack_blurb: "Bundle your assets, scripts, images and styles",
  doc_learn: "Familiar With TypeScript already?",
  doc_learn_3_5_release_notes_title: "Release Notes",
  doc_learn_handbook_blurb: "The TypeScript language reference",
  doc_learn_d_ts_title: "d.ts Guide",
  doc_learn_d_ts_blurb: "Learn how to declare the shape of JS",
  doc_learn_playground_blurb: "Explore and share TypeScript online",
  nav_: {
    id: "foo",
    defaultMessage: "foo",
  },
}
